module.exports = __webpack_public_path__ + "img/cadeira_azul.79726d1c.png";